import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";

export default function CreateSceneSize({ setContainerSize }) {
  const [width, setWidth] = React.useState(10);
  const [height, setHeight] = React.useState(10);

  const cellSize = 20;

  const handleSizeChange = (w, h) => {
    setWidth(w);
    setHeight(h);
    setContainerSize({ width: w, height: h });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ mr: 2, height: 200 }}>
        {/* <Typography align="center" variant="caption">
          Y
        </Typography> */}
        <Slider
          orientation="vertical"
          value={height}
          min={6}
          max={20}
          step={1}
          onChange={(e, v) => handleSizeChange(width, v)}
          valueLabelDisplay="auto"
        />
      </Box>

      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Typography variant="body2" gutterBottom>
          {width} × {height}
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${width}, ${cellSize}px)`,
            gridTemplateRows: `repeat(${height}, ${cellSize}px)`,
            gap: "1px",
            backgroundColor: "#ccc",
          }}
        >
          {Array.from({ length: width * height }).map((_, i) => (
            <Box
              key={i}
              sx={{
                width: cellSize,
                height: cellSize,
                backgroundColor: "#e3f2fd",
                border: "1px solid #90caf9",
              }}
            />
          ))}
        </Box>

        <Box sx={{ width: 200, mt: 2 }}>
          {/* <Typography align="center" variant="caption">
            X
          </Typography> */}
          <Slider
            value={width}
            min={6}
            max={20}
            step={1}
            onChange={(e, v) => handleSizeChange(v, height)}
            valueLabelDisplay="auto"
          />
        </Box>
      </Box>
    </Box>
  );
}
